import { render, staticRenderFns } from "./ValidMFA.vue?vue&type=template&id=05f88834&scoped=true";
import script from "./ValidMFA.vue?vue&type=script&lang=js";
export * from "./ValidMFA.vue?vue&type=script&lang=js";
import style0 from "./ValidMFA.vue?vue&type=style&index=0&id=05f88834&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "05f88834", null);
export default component.exports;